import Asset from './Asset';

export default Asset;
